<template>
  <transition name="fade">
    <div class="full-screen-modal">
      <div class="popup-wrapper">
        <div
          id="image-manager-popup"
          class="close-btn"
          @click="$emit('close')"
          data-shortcut-esc="imageManagerPopup"
        >
          <span></span>
        </div>
        <image-manager
          :isCallByEditor="true"
          :isLogo="isLogo"
          @reflectImage="reflectImage"
        />
      </div>
    </div>
  </transition>
</template>

<script>
import ImageManager from '@/components/ImageManager/ImageManager'
import ShortCutBase from '@/mixins/ShortCutBase'

export default {
  props: [
    'isLogo',
  ],
  mixins: [
    ShortCutBase
  ],
  components: {
    ImageManager
  },
  methods: {
    reflectImage (image) {
      this.$emit('reflectImage', {
        image,
        isDetailEditor: false,
      })
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.full-screen-modal {
  background: #f8f8f8;
}

.popup-wrapper {
  height: 100%;
  padding: $navbarHeight 100px 0 100px;
}
</style>

<style lang="scss">
#image-manager-popup.close-btn {
  span::before, span::after {
    background: $commonFontColor;
  }
}
</style>
